export const PAGE_LIMIT = 20;

// Role labels + the role list are served by the backend (GET /me/roles) and read
// via useRoles() — no hardcoded role catalogue here. See hooks/useRoles.ts.

/** Column widths: Name | Email | Group | Role | Actions (Edit + Impersonate) */
export const TABLE_COLS = "1fr 1.5fr 1fr 148px 92px";

export const COL_HEADER_SX = {
  fontSize: 11,
  fontWeight: 700,
  color: "var(--color-dark-dust)",
  textTransform: "uppercase" as const,
  letterSpacing: "2px",
};

export const FILTER_SELECT_SX = {
  height: 52,
  borderRadius: "var(--radius-btn)",
  bgcolor: "background.paper",
  fontFamily: "var(--font-lato)",
  fontSize: 16,
  color: "var(--color-rodeo-black)",
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "var(--color-smoke)" },
  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "var(--color-rodeo-dust)" },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "var(--color-dark-dust)" },
  "& .MuiSelect-icon": { color: "var(--color-graphite)" },
};
